export function countdown() {
  const els = document.querySelectorAll('.js-countdown-el');
  if(els.length) {
    els.forEach((el) => {
      const startDateString = el.dataset.start;
      const endDateString = el.dataset.end;
      const endText = el.dataset.endText;
      if (startDateString && endDateString) {
        // しきい値はすべて JST(+09:00) を明示した絶対時刻。
        // 絶対時刻同士の比較なので、ブラウザのタイムゾーンに関係なく JST 基準で判定される。
        // 開始日・終了日が逆に設定されていても正しい範囲として扱えるよう、早い方を開始・遅い方を終了に正規化する。
        let startStr = startDateString;
        let endStr = endDateString;
        if (new Date(startStr + 'T00:00:00+09:00') > new Date(endStr + 'T00:00:00+09:00')) {
          [startStr, endStr] = [endStr, startStr];
        }
        const startMidnight = new Date(startStr + 'T00:00:00+09:00');
        const endMidnight = new Date(endStr + 'T00:00:00+09:00');
        const endDate = new Date(endStr + 'T23:59:59+09:00');

        function update() {
          const now = new Date();

          if (now < startMidnight) {
            const diff = startMidnight - now;
            const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
            el.innerText = fabfLabels.countdownDaysUntil.replace('%d', days);
            el.style.color = '';
          } else if (now <= endDate) {
            // 会期中（◯日目・最終日）は文字色を赤にする
            if (now >= endMidnight) {
              el.innerText = fabfLabels.countdownLastDay;
            } else {
              const diff = now - startMidnight;
              const day = Math.floor(diff / (1000 * 60 * 60 * 24)) + 1;
              el.innerText = fabfLabels.countdownDayOf.replace('%d', day);
            }
            el.style.color = 'red';
          } else {
            if (endText) {
              el.innerText = endText;
            } else {
              el.innerText = fabfLabels.countdownEnded;
            }
            el.style.color = '';
          }
        }

        update();
        setInterval(update, 60000);
      }
    })
  }
}